<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head.head-border
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb(:data="items")
        el-col.pt-5.text-right(:span="15")
          el-button(v-if="true" type="primary" size="mini" :loading="loading" @click="placeOrder") 确定下单
          el-button(v-if="true" type="primary" size="mini" @click="$router.go(-1)") 返回
    div(style="height:70px")
    el-main.white.pa-3.ma-4
      el-row.py-3(type="flex" justify="center" :gutter="10")
        el-col(:span="4")
          el-select.w-100(v-model="list.supplier" size="mini" filterable remote placeholder="请搜索供应商" :remote-method="getSupplyList" :loading="loadingSupply" clearable)
            el-option(v-for="item in supply" :key="item.code" :label="item.name" :value="item.code")
        el-col(:span="4")
          el-input.w-100(v-model="list.code_ct" size="mini" placeholder="请输入合同号" clearable)
        el-col(:span="4")
          el-input.w-100(v-model="list.code_material" size="mini" placeholder="请输入物料编码" clearable)
        el-col(:span="4")
          el-input.w-100(v-model="list.name_material" size="mini" placeholder="请输入物料名称" clearable)
        el-col(:span="4")
          el-select.w-100(v-model="list.buy_org" size="mini" :filter-method="sourcebuyorg" filterable placeholder="采购组织" clearable)
            el-option(v-for="item in buyorg" :key="item.pk_org" :label="item.name" :value="item.pk_org")
        el-col(:span="4")
          el-button(type="primary" @click="getOrder" size="mini" :loading="loading") 查询
          el-button(@click="clear" size="mini" :loading="loading") 重置
      template(v-for="(item,i) in data")
        div.grey--lighten1.pl-3(:key="i" style="height:48px;line-height:48px;font-size:14px;color:#909399;font-weight: bold;") 需求信息
        el-divider.my-0
        div.grey--lighten1.pl-3.py-3(style="line-height:24px;font-size:14px;color:#909399;font-weight: bold;")
          el-row
            el-col(:span="4")
              span 物料名称：{{item.head.name_material}}
            el-col(:span="2")
              span 数量：{{item.head.source_num}}
            el-col(:span="5")
              span 需求组织：{{item.head.name_stock_org}}
            el-col(:span="5")
              span 采购组织：{{item.head.name_buy_org}}
            el-col(:span="4")
              span 需求时间：{{item.head.trans_date}}
            el-col(:span="4")
              span 备注：{{item.head.remark}}
        el-divider.my-0
        el-table.mb-6(:data="item.body" style="width: 100%" border header-cell-class-name="grey--lighten1" size="mini")
          el-table-column(prop="row_num" label="行号" width="50")
          el-table-column(prop="ct_code" label="合同档案编号" width="120")
          el-table-column(prop="ct_name" label="合同名称" width="150" show-overflow-tooltip)
          el-table-column(prop="name_supplier" label="供应商" show-overflow-tooltip)
          el-table-column(prop="price" label="无税价格(元)" width="140")
          el-table-column(prop="taxprice" label="含税价格(元)" width="140")
          el-table-column(prop="num_sub" label="可执行数量" width="120")
            template(slot-scope="scope")
              span {{scope.row.num_sub==-1?'不限':scope.row.num_sub}}
          el-table-column(prop="source_num" label="下单数量" width="170")
            template(slot-scope="scope")
              el-input-number.w-100(v-if="scope.row.num_sub==-1" size="mini" v-model="scope.row.source_num" :precision="3" controls-position="right" :min="0" placeholder="下单数量")
              el-input-number.w-100(v-else v-model="scope.row.source_num" size="mini" :precision="3" controls-position="right" :min="0" :max="item.head.source_num" placeholder="下单数量")
          el-table-column(prop="trans_date" label="期望到货" width="160")
            template(slot-scope="scope")
              el-date-picker.w-100(v-model="scope.row.trans_date" size="mini" value-format="yyyy-MM-dd" type="date" placeholder="期望到货")
</template>
<script>
export default {
  data() {
    return {
      h: "",
      data: [],
      loading: false,
      items: [
        {
          path: "/purchase/purchase_demand",
          meta: {
            title: "采购需求",
          },
        },
        {
          path: this.$route.path,
          meta: {
            title: "下单",
          },
        },
      ],
      list: {
        buy_org: null,
        code_ct: null,
        code_material: null,
        name_material: null,
        supplier: null,
        ids: null,
      },
      supply: [],
      loadingSupply: false,
    };
  },
  methods: {
    async getOrder() {
      let res = await this.$api.purchase_demand.getOrderQueryList(this.list);
      if (res) {
        this.data = res.data;
        for (var i in this.data) {
          if (this.data[i].body.length == 1) {
            if (this.data[i].body[0].num_sub == -1) {
              this.data[i].body[0].source_num = this.data[i].head.source_num;
            } else if (
              this.data[i].body[0].num_sub < this.data[i].head.source_num
            ) {
              this.data[i].body[0].source_num = this.data[i].body[0].num_sub;
            } else {
              this.data[i].body[0].source_num = this.data[i].head.source_num;
            }
          }
        }
      }
    },
    async placeOrder() {
      this.loading = true;
      for (const i in this.data) {
        const num=this.data[i].body.reduce((prev, curr) => {
          const value = Number(curr.source_num);
          if (!isNaN(value)) {
            return prev + curr.source_num;
          } else {
            return prev;
          }
        }, 0);
        if(num===0){
          this.$notify({
            message: `物料${this.data[i].head.name_material} 未填写下单数量，无法下单！`,
            type: "error",
          });
          this.loading = false;
          return false
        }
      }
      let res = await this.$api.purchase_demand.placeOrder(this.data);
      this.loading = false;
      if (res) {
        this.$notify({
          message: "下单成功",
          type: "success",
        });
        this.goto("/purchase/purchase_order");
      }
    },
    clear() {
      this.list.buy_org = null;
      this.list.code_ct = null;
      this.list.code_material = null;
      this.list.name_material = null;
      this.list.supplier = null;
      this.getOrder();
    },
    async getSupplyList(query) {
      if (!query) {
        return false;
      }
      localStorage.setItem("PurchaseOrderAdd_query", query);
      this.loadingSupply = true;
      let res = await this.$api.supplier.getotherList({
        key_name: query,
        page_num: 1,
        page_size: 100,
        no_check: 1,
        checkstatus: 3,
      });
      this.loadingSupply = false;
      if (res) {
        this.supply = res.data;
      }
    },
  },

  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    if (this.$store.state.token && this.$store.state.purchase_org == false){
      this.getPurchaseOrg();
    }
    this.list.ids = this.$route.query.ids;
    this.getOrder();
  },
};
</script>
